import React from "react";
import { Clock, Plane, Wind } from "lucide-react";

// Estimated Flight Time & Arrival (Auto-calculated when aircraft selected)
export default function EtaInfoCard({ leg, t }) {
  return (
    <div className="rounded-lg overflow-hidden border border-blue-500/20">
      {/* Airport route names */}
      {(leg.origin_info || leg.dest_info) && (
        <p className="text-[11px] text-slate-400 leading-snug px-3 pt-2.5">
          {leg.origin_info ? `${leg.origin_info.name}, ${leg.origin_info.city}` : leg.origin}
          <span className="mx-1 text-slate-400">{"→"}</span>
          {leg.dest_info ? `${leg.dest_info.name}, ${leg.dest_info.city}` : leg.destination}
        </p>
      )}
      {/* Flight Time row */}
      <div className="flex items-center justify-between px-3 py-2.5 bg-blue-500/10">
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4 text-blue-400 shrink-0" />
          <span className="text-xs text-blue-400 font-medium uppercase tracking-wider">
            {t("newTrip.flightTime")}
          </span>
        </div>
        <span className="text-xl font-bold font-mono text-white">{leg.ete_formatted}</span>
      </div>
      {/* ETA row */}
      {leg.departure_time && leg.arrival_date ? (
        <div className="flex items-center justify-between px-3 py-2.5 bg-[#0f172a] border-t border-blue-500/20">
          <div className="flex items-center gap-2">
            <Plane className="w-3.5 h-3.5 text-green-400 shrink-0" />
            <span className="text-xs text-green-400 font-medium uppercase tracking-wider">ETA</span>
          </div>
          <div className="text-right">
            <span className="text-xl font-bold font-mono text-white">
              {leg.arrival_time || "—"}
            </span>
            <p className="text-[10px] text-slate-400 mt-0.5">{leg.arrival_date}</p>
            {leg.tz_diff_hours !== null && (
              <p className="text-[10px] text-slate-400 mt-0.5">
                {t("newTrip.tzDiff", {
                  value: leg.tz_diff_hours > 0 ? `+${leg.tz_diff_hours}` : leg.tz_diff_hours,
                })}
              </p>
            )}
          </div>
        </div>
      ) : (
        <p className="text-[11px] text-slate-400 italic px-3 py-2 bg-[#0f172a] border-t border-blue-500/20">
          {t("newTrip.enterDepartureForEta")}
        </p>
      )}
      {/* Winds-aloft hint — ALWAYS shown when we have a calculated ETE,
          so the manager sees that Altiv considers winds aloft even when
          the delta is negligible or the forecast is unavailable. */}
      {(() => {
        const d = leg.wind?.delta_minutes;
        const hasImpact = d != null && Math.abs(d) >= 3;
        const faster = d != null && d < 0;
        const minutes = d != null ? Math.abs(d) : 0;
        const color = hasImpact
          ? faster
            ? "text-emerald-400"
            : "text-amber-400"
          : "text-slate-400";
        const msg = hasImpact
          ? faster
            ? t("newTrip.windsFaster", { minutes })
            : t("newTrip.windsSlower", { minutes })
          : t("newTrip.windsNoImpact");
        return (
          <div
            className={`flex items-center gap-1.5 px-3 py-2 bg-[#0f172a] border-t border-blue-500/20 text-[11px] leading-tight ${color}`}
          >
            <Wind className="w-3 h-3 flex-shrink-0" />
            <span>{msg}</span>
          </div>
        );
      })()}
    </div>
  );
}
